import {
  GET_CSP_CONFIG_LIST_FULFILLED,
  CspConfigActionTypes,
  CspConfigState,
  GET_CSP_CONFIG_LIST,
  GET_CSP_CONFIG_PENDING,
  GET_CSP_CONFIG_FULFILLED,
  DELETE_CSP_CONFIG_FULFILLED,
  SELECT_CSP_CONFIG,
  OPEN_CSP_CONFIG_CREATE_PAGE,
  CLOSE_CSP_CONFIG_CREATE_PAGE,
  OPEN_CSP_CONFIG_EDIT_PAGE,
  CLOSE_CSP_CONFIG_EDIT_PAGE,
  CREATE_CSP_CONFIG_FULFILLED,
  SET_CSP_CONFIG_LOADING,
  CREATE_CSP_CONFIG_PENDING,
} from './cspConfig.types';
import { adaptCspConfig, adaptCspConfigs } from './cspConfig.adapter';

export const initialState: CspConfigState = {
  entities: [],
  single: null,
  selected: [],
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isEditPopupOpen: false,
    isLoading: false,
  },
};

export default function cspConfigReducer(
  state = initialState,
  action: CspConfigActionTypes,
): CspConfigState {
  switch (action.type) {
    case GET_CSP_CONFIG_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_CSP_CONFIG_LIST_FULFILLED:
      return {
        ...state,
        entities: adaptCspConfigs(action.payload.data.data ?? []),
        selected: [],
      };

    case GET_CSP_CONFIG_PENDING:
      return {
        ...state,
        single: state.single?.cspid === state.selected[0]?.cspid ? state.single : null,
      };

    case GET_CSP_CONFIG_FULFILLED: {
      const [cspConfig] = action.payload.data.data ?? [];

      return {
        ...state,
        single: cspConfig == null ? null : adaptCspConfig(cspConfig),
      };
    }

    case SELECT_CSP_CONFIG:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_CSP_CONFIG_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_CSP_CONFIG_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_CSP_CONFIG_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case OPEN_CSP_CONFIG_CREATE_PAGE:
      return {
        ...state,
        single: null,
        createdId: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: true,
        },
      };

    case CLOSE_CSP_CONFIG_CREATE_PAGE:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isCreatePopupOpen: false,
        },
      };

    case OPEN_CSP_CONFIG_EDIT_PAGE:
      return {
        ...state,
        ui: {
          ...state.ui,
          isEditPopupOpen: true,
        },
      };

    case CLOSE_CSP_CONFIG_EDIT_PAGE:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isEditPopupOpen: false,
        },
      };

    case SET_CSP_CONFIG_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
